import { Injectable } from '@angular/core';
import { generateClient } from '@aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateProductMaskDescriptionInput,
    DeleteProductMaskDescriptionInput,
    ProductMaskDescription,
    UpdateProductMaskDescriptionInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ProductMaskDescriptionService {
    private amplifyClient = generateClient();

    async getProductMaskDescription(
        id: string
    ): Promise<ProductMaskDescription> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductMaskDescription,
                    variables: {
                        id
                    }
                })
            ).data.getProductMaskDescription;
            if (data) return data as ProductMaskDescription;
        } catch (error) {
            console.error('Error finding ProductMaskDescription:', error);
            return null;
        }
    }

    async listProductMaskDescriptions(): Promise<ProductMaskDescription[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductMaskDescriptions
                })
            ).data.listProductMaskDescriptions.items;
            if (data) return data as ProductMaskDescription[];
        } catch (error) {
            console.error('Error finding ProductMaskDescription:', error);
            return null;
        }
    }

    async createProductMaskDescription(
        input: CreateProductMaskDescriptionInput
    ): Promise<ProductMaskDescription> {
        try {
            const ProductMaskDescription = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductMaskDescription,
                    variables: {
                        input
                    }
                })
            ).data.createProductMaskDescription;
            if (ProductMaskDescription)
                return ProductMaskDescription as ProductMaskDescription;
        } catch (error) {
            console.error('Error creating ProductMaskDescription:', error);
            return null;
        }
    }

    async updateProductMaskDescription(
        input: UpdateProductMaskDescriptionInput
    ): Promise<ProductMaskDescription> {
        try {
            const ProductMaskDescription = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductMaskDescription,
                    variables: {
                        input
                    }
                })
            ).data.updateProductMaskDescription;
            if (ProductMaskDescription)
                return ProductMaskDescription as ProductMaskDescription;
        } catch (error) {
            console.error('Error updating ProductMaskDescription:', error);
            return null;
        }
    }

    async deleteProductMaskDescription(
        input: DeleteProductMaskDescriptionInput
    ): Promise<ProductMaskDescription> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteProductMaskDescription,
                    variables: {
                        input
                    }
                })
            ).data.deleteProductMaskDescription;
            if (date) return date as ProductMaskDescription;
        } catch (error) {
            console.error('Error creating ProductMaskDescription:', error);
            return null;
        }
    }
}
